import React from 'react';
import CalculusOfCare from '../components/CalculusOfCare';

function CalculusOfCarePage() {
  return <CalculusOfCare />;
}

export default CalculusOfCarePage;
